import React from "react";
import { Mail, MapPin, Phone, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const quickLinks = [{
  label: "Home",
  path: "/HomePage"
}, {
  label: "Healing Paths",
  path: "/OurHealingPathsPage"
}, {
  label: "Our Team",
  path: "/TheOstaraTeamPage"
}];
const products = ["Individual Therapy", "Couples Counseling", "Trauma Recovery", "Clinical Supervision", "Career Growth"];
export default function CorporateFooter() {
  return <section data-section-id="122859" id="footer" className="dark bg-background text-foreground pt-20 pb-8 border-t border-border">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start gap-6">
            <Link to="/HomePage" className="inline-block">
              <img src="https://wise-pup.10web.cloud/wp-content/uploads/2026/03/Ostara-White.png" alt="Ostara Counseling Logo" className="h-12 w-auto object-contain" />
            </Link>
            <p className="text-sm leading-relaxed text-muted-foreground font-sans">
              A season for growth, a space for healing. Ostara Counseling provides modern, nature-inspired mental health support for individuals and families across Massachusetts.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-xl font-serif font-semibold tracking-tight text-foreground">
              Quick Links
            </h3>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.path} className="group flex items-center text-muted-foreground hover:text-accent transition-colors duration-200 font-sans">
                    <ChevronRight className="w-4 h-4 mr-2 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all duration-200" />
                    <span>{link.label}</span>
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-xl font-serif font-semibold tracking-tight text-foreground"><br /></h3>
            <ul className="flex flex-col gap-3">
              {products.map((product, i) => <li key={i} data-index={i}>
                  <Link to="/OurHealingPathsPage" className="group flex items-center text-muted-foreground hover:text-accent transition-colors duration-200 font-sans">
                    <ChevronRight className="w-4 h-4 mr-2 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all duration-200" />
                    
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-xl font-serif font-semibold tracking-tight text-foreground">
              Connect
            </h3>
            <ul className="flex flex-col gap-4 text-muted-foreground">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                <span className="leading-relaxed text-sm font-sans">Serving all of Massachusetts via Telehealth. <br />Main Office: 734 Longmeadow Street Longmeadow, MA 01106</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-accent shrink-0" />
                <span className="text-sm font-sans">(413) 858-7004</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-accent shrink-0" />
                <span className="text-sm font-sans">admin@ostaracounseling.com</span>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-border mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground font-sans">
          <p>© 2026 Ostara Counseling. All rights reserved.</p>
          <p className="font-medium tracking-wide text-accent opacity-80">A Season for Growth and Renewal</p>
        </div>
      </div>
    </section>;
}